import React from "react"
import parse from "html-react-parser"
import {
  IconButton,
  StaticSnackbar,
  SnackbarProps
} from "../../../../../mp-shared-components/generic-shared-components/components"
import { Stack, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { FaIcon } from "../../../../icons"

interface Props {
  severity: SnackbarProps["severity"]
  message: string
  currentBannerIndex: number
  totalBanners: number
  allowPermanentDismiss: boolean
  onDismiss: () => void
  onChange: (nextBannerIndex: number) => void
}

const AnnouncementsBanner: React.FC<Props> = ({
  severity,
  message,
  currentBannerIndex,
  totalBanners,
  allowPermanentDismiss,
  onDismiss,
  onChange
}) => {
  const { classes } = useStyles()

  return (
    <StaticSnackbar
      variant="dark"
      className={classes.banner}
      severity={severity}
      message={
        <Stack spacing={1} alignItems="flex-start">
          {!!message && (
            <Typography variant="body1">{parse(message)}</Typography>
          )}
          {totalBanners > 1 && (
            <Stack
              spacing={2}
              direction="row"
              className={classes.paginationContainer}
            >
              <IconButton
                size="xsmall"
                disabled={currentBannerIndex <= 0}
                onClick={() => {
                  if (currentBannerIndex <= 0) return
                  onChange(currentBannerIndex - 1)
                }}
              >
                <FaIcon name="angle-left" />
              </IconButton>

              <Typography variant="h6">
                {currentBannerIndex + 1} of {totalBanners}
              </Typography>
              <IconButton
                size="xsmall"
                disabled={currentBannerIndex >= totalBanners - 1}
                onClick={() => {
                  if (currentBannerIndex >= totalBanners - 1) return
                  onChange(currentBannerIndex + 1)
                }}
              >
                <FaIcon name="angle-right" />
              </IconButton>
            </Stack>
          )}
        </Stack>
      }
      action={allowPermanentDismiss && { Dismiss: onDismiss }}
    />
  )
}

export default AnnouncementsBanner
